import { verifyEmailCode } from 'actions/member';

export default store => ({
	path: 'verify',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container').default;
					cb(null, component);
				},
				'verify',
			),
		onEnter: ({ location: { query: { code = '' } } }) => {
			store.dispatch(verifyEmailCode(code));
		},
	},
});



// WEBPACK FOOTER //
// ./src/routes/Verify/index.js